// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const teamMemberSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  userName: z.string().max(200),
  slug: z.string().max(200).optional(),
  userEmail: z.string().max(200).optional(),
  userAvatar: z.string().max(200).optional(),
  role: z.string().max(50),
  isAgent: z.boolean(),
  joinedAt: z.string().max(200).optional(),
  raciAssignments: z.record(z.string(), z.unknown()).optional(),
  productId: z.string().max(100).optional(),
  tenantId: z.string().max(100).optional(),
  lastHeartbeat: z.string().max(50).datetime().optional(),
  containerStatus: z.string().max(20).optional(),
})

export type TeamMemberInput = z.infer<typeof teamMemberSchema>
